module.exports = __webpack_public_path__ + "static/img/ezwel-renewal-img-03-04@t.f60793c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezwel-renewal/optimized/ezwel-renewal-img-03-04@t.jpg
// module id = nWid
// module chunks = 0